import { Locale } from '@libs/core';

export const afterpayConfig = {
    [Locale['en-CA']]: {
        mpid: process.env.NEXT_PUBLIC_AFTERPAY_CA_MPID,
        placementId: process.env.NEXT_PUBLIC_AFTERPAY_CA_PLACEMENTID,
        placementIdCheckout: process.env.NEXT_PUBLIC_AFTERPAY_CA_PLACEMENTID_CHECKOUT,
    },
    [Locale['en-US']]: {
        mpid: process.env.NEXT_PUBLIC_AFTERPAY_US_MPID,
        placementId: process.env.NEXT_PUBLIC_AFTERPAY_US_PLACEMENTID,
        placementIdCheckout: process.env.NEXT_PUBLIC_AFTERPAY_US_PLACEMENTID_CHECKOUT,
    },
};
